var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCartIcon = function SvgCartIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#CartIcon_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.889 5.778a.89.89 0 0 1 0-1.778h1.63a1.794 1.794 0 0 1 1.786 1.62l.063.615 17.937-.009v-.004a1.692 1.692 0 0 1 1.297.607 1.692 1.692 0 0 1 .38 1.331l-.008.047-1.461 8.251c-.137.795-1.123 1.971-1.123 1.971s-1.328.782-2.136.782H13.698l.1.965a1.838 1.838 0 0 0 1.362 1.601h1.978l.088-.001.088.001h9.044l.088-.001.088.001h3.704a.89.89 0 0 1 0 1.778h-.98a3.1 3.1 0 0 1 .299 1.332c0 .858-.348 1.637-.911 2.2a3.102 3.102 0 0 1-2.2.91 3.1 3.1 0 0 1-2.2-.91 3.101 3.101 0 0 1-.911-2.2c0-.477.107-.928.299-1.332h-3.596a3.102 3.102 0 0 1-.612 3.532 3.102 3.102 0 0 1-2.2.911 3.102 3.102 0 0 1-2.2-.911 3.101 3.101 0 0 1-.912-2.2 3.1 3.1 0 0 1 .366-1.464 3.602 3.602 0 0 1-2.446-3.067L10.542 5.801a.029.029 0 0 0-.01-.02.032.032 0 0 0-.014-.003H8.89Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.55 8.006.966 9.427h13.738c.377 0 .724-.133.99-.358.267-.226.456-.546.518-.915l.001-.007 1.444-8.156-17.657.009Zm12.122 3.824a.886.886 0 0 1 0 1.77l-6.666.004a.886.886 0 0 1 0-1.77l6.666-.004Zm-7.39 11.725h-.114c-.347.015-.66.16-.887.388l.001.001c-.24.241-.39.575-.39.943a1.33 1.33 0 0 0 1.333 1.334 1.33 1.33 0 0 0 1.334-1.334c0-.368-.15-.702-.39-.943l.002-.001a1.333 1.333 0 0 0-.888-.388Zm9.221 0h-.114a1.328 1.328 0 0 0-1.276 1.332 1.33 1.33 0 0 0 1.333 1.333 1.33 1.33 0 0 0 1.333-1.333 1.33 1.33 0 0 0-1.276-1.332Z",
    fill: "#222038"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "CartIcon_svg__a",
    x: 0,
    y: 0,
    width: 40,
    height: 39.998,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2425_2284"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2425_2284",
    result: "shape"
  })))));
};
export default SvgCartIcon;